<div class="jw-modal">
    <div class="jw-modal-body" [ngStyle]="{'direction': isRightToLeft}" style="{{modelstyle}}">
        <ng-content></ng-content>
    </div>
</div>
<div class="jw-modal-background"></div>